<template>
    <jet-dialog-modal ref="modal" :show="show_modal" maxWidth="xl" @close="show_modal = false">
        <template v-slot:title>
            <div class="flex text-gray-700 text-base font-medium">
                <span>Configure your SAML2 Identity Provider</span>
                <!-- <vue-feather type="link-2" class="h-5 w-5 ml-2 self-center"></vue-feather> -->
            </div>
        </template>
        <template v-slot:content>

            <div class="text-gray-600 text-sm font-bold mb-5">
                Please provide your IdP metadata fields below:
            </div>

            <div class="text-gray-600 grid grid-cols-6 gap-4">

                <div class="col-span-6 flex flex-col justify-center pr-6">
                    <span class="text-sm font-bold pl-1 flex items-center">Label <InformationCircleIcon
                            class="w-4 h-4 ml-1 text-gray-400 cursor-pointer"
                            v-tippy="{ content: 'Will be displayed on the login page', appendTo: 'parent', zIndex: 99999, placement: 'right' }">
                        </InformationCircleIcon></span>
                    <jet-input id="saml_label" type="text" ref="saml_label" class="mt-1 mr-6 block w-full"
                        v-model="saml_label" placeholder="My Identity Provider name" />
                </div>

                <div class="col-span-6 flex flex-col justify-center pr-6">
                    <span class="text-sm font-bold pl-1 flex items-center">Domain <InformationCircleIcon
                            class="w-4 h-4 ml-1 text-gray-400 cursor-pointer"
                            v-tippy="{ content: 'The email domain for your organization. If more than one domain use a comma as separator.', appendTo: 'parent', zIndex: 99999, placement: 'right' }">
                        </InformationCircleIcon></span>
                    <jet-input id="sso_domains" type="text" ref="sso_domains" class="mt-1 mr-6 block w-full"
                        v-model="sso_domains" placeholder="mycompany.com" />
                </div>

                <div class="col-span-6 flex flex-col justify-center pr-6">
                    <span class="text-sm font-bold pl-1 flex items-center">Entity ID <InformationCircleIcon
                            class="w-4 h-4 ml-1 text-gray-400 cursor-pointer"
                            v-tippy="{ content: 'This is an URL, it can be the Metadata or the Issuer', appendTo: 'parent', zIndex: 99999, placement: 'right' }">
                        </InformationCircleIcon></span>
                    <jet-input id="saml_entity_id" type="text" ref="saml_entity_id" class="mt-1 mr-6 block w-full"
                        v-model="saml_entity_id" placeholder="https://" />
                </div>

                <div class="col-span-6 flex flex-col justify-center pr-6">
                    <span class="text-sm font-bold pl-1 flex items-center">Single Sign On URL <InformationCircleIcon
                            class="w-4 h-4 ml-1 text-gray-400 cursor-pointer"
                            v-tippy="{ content: 'You must enter your IdP Sign on URL', appendTo: 'parent', zIndex: 99999, placement: 'right' }">
                        </InformationCircleIcon></span>
                    <jet-input id="saml_signon_url" type="url" ref="saml_signon_url" class="mt-1 mr-6 block w-full"
                        v-model="saml_signon_url" placeholder="https://" />
                </div>

                <div class="col-span-6 flex flex-col justify-center pr-6">
                    <span class="text-sm font-bold pl-1 flex items-center">Sign Out URL <span
                            class="font-normal text-gray-500 pl-1">(optional)</span></span>
                    <jet-input id="saml_signout_url" type="url" ref="saml_signout_url" class="mt-1 mr-6 block w-full"
                        v-model="saml_signout_url" placeholder="https://" />
                </div>

                <div class="col-span-6 flex flex-col justify-center pr-6">
                    <span class="text-sm font-bold pl-1 flex items-center">X.509 certificate <InformationCircleIcon
                            class="w-4 h-4 ml-1 text-gray-400 cursor-pointer"
                            v-tippy="{ content: 'Make sure you copy and paste the whole certificate, starting with -----BEGIN CERTIFICATE----- and ending with -----END CERTIFICATE-----', appendTo: 'parent', zIndex: 99999, placement: 'right' }">
                        </InformationCircleIcon></span>
                    <textarea id="saml_certificate"
                        class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 mr-6 block w-full h-28"
                        ref="saml_certificate" v-model="saml_certificate"
                        placeholder="-----BEGIN CERTIFICATE-----&#10;…&#10;-----END CERTIFICATE-----"></textarea>
                </div>

            </div>
        </template>
        <template v-slot:footer>
            <div class="flex w-full flex-row justify-between">
                <div class="flex w-full">
                    <jet-button v-if="saml_tenant" class="w-full place-content-center" :disabled="!formValid"
                        @click="save">
                        Update infos
                    </jet-button>
                    <jet-button v-else class="w-full place-content-center" :disabled="!formValid" @click="save">
                        Enable Saml
                    </jet-button>
                </div>
            </div>
        </template>
    </jet-dialog-modal>
</template>

<script>

import JetDialogModal from '@/Jetstream/DialogModal'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetLabel from '@/Jetstream/Label'
import { InformationCircleIcon } from "@heroicons/vue/24/solid";


export default {

    props: ['saml_tenant', 'domains'],

    components: {
        JetDialogModal, JetButton, JetInput, JetLabel,
        InformationCircleIcon
    },

    data() {
        return {
            show_modal: false,
            saml_label: null,
            saml_entity_id: null,
            saml_signon_url: null,
            saml_certificate: null,
            saml_signout_url: '',
            sso_domains: '',
        }
    },

    created: function () {

    },

    emits: ["callback"],

    methods: {
        parseTenant: function () {
            if (this.saml_tenant) {
                this.saml_label = this.saml_tenant.key
                this.saml_entity_id = this.saml_tenant.idp_entity_id
                this.saml_signon_url = this.saml_tenant.idp_login_url
                this.saml_certificate = "-----BEGIN CERTIFICATE-----\n" + this.saml_tenant.idp_x509_cert + "\n-----END CERTIFICATE-----",
                    this.saml_signout_url = this.saml_tenant.idp_logout_url

            } else {
                this.saml_label = null
                this.saml_entity_id = null
                this.saml_signon_url = null
                this.saml_certificate = null
                this.saml_signout_url = ''
            }
            this.sso_domains = this.domains
            // this.sso_domains = this.$page.props.user.current_team.sso_domains
            // if (!this.sso_domains) {
            //     this.sso_domains = this.$page.props.user.current_team.owner.email.split('@')[1]
            // }
        },
        open: function () {
            this.parseTenant()
            this.show_modal = true
            setTimeout(function () {
                this.$refs.saml_label.focus()
            }.bind(this), 300)
        },
        close: function () {
            this.$emit('callback', {
                saml_label: null,
                saml_entity_id: null,
                saml_signon_url: null,
                saml_certificate: null,
                saml_signout_url: null,
                sso_domains: null
            })
            this.show_modal = false
        },
        // is_form_valid: function() {
        //     return this.validateUrl(this.saml_signon_url)
        //         && this.validateNotempty(this.saml_label)
        //         && this.validateNotempty(this.saml_entity_id)
        //         && this.validateCertificate(this.saml_certificate)
        // },
        save: function () {
            //console.log("SAVE", this.formValid)
            if (this.formValid) {
                this.$emit('callback', {
                    saml_signon_url: this.saml_signon_url,
                    saml_label: this.saml_label,
                    saml_entity_id: this.saml_entity_id,
                    saml_certificate: this.saml_certificate,
                    saml_signout_url: this.saml_signout_url,
                    sso_domains: this.sso_domains
                })
            }
            this.show_modal = false
        },
        validateDomains: function (value) {
            var re = /^([a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})(,\s*([a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}))*$/
            return re.test(value)
        },
        validateUrl: function (value) {
            return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
        },
        validateNotempty: function (value) {
            var re = /^\s*\S+.*/
            return re.test(value)
        },
        validateCertificate: function (value) {
            const re = /^-----BEGIN CERTIFICATE-----\n[ A-Za-z0-9+/=\n]+\n-----END CERTIFICATE-----$/
            return re.test(value)
        }
    },

    // watch: {
    //     saml_label(value){
    //       this.saml_label = value;
    //       this.formValid = this.is_form_valid()
    //     },
    //     saml_entity_id(value){
    //       this.saml_entity_id = value;
    //       this.formValid = this.validateNotempty(value)
    //     },
    //     saml_signon_url(value){
    //       this.url = value;
    //       this.formValid = this.validateUrl(value) && this.validateNotempty(value)
    //     },
    //     saml_certificate(value){
    //       this.url = value;
    //       this.formValid = this.validateUrl(value) && this.validateNotempty(value)
    //     }
    // },
    computed: {
        formValid() {
            return this.validateNotempty(this.saml_label)
                && this.validateUrl(this.saml_entity_id)
                && this.validateUrl(this.saml_signon_url)
                && this.validateCertificate(this.saml_certificate)
                && this.saml_certificate.length > 100
                && this.validateDomains(this.sso_domains)
                && (!this.validateNotempty(this.saml_signout_url) || this.validateUrl(this.saml_signout_url))
        },
    }

}

</script>
